import React, { useState } from "react";
import Modal from "../Modal";

const RegenerateVisualModal = ({
  sceneNumber,
  initialPrompt,
  onClose,
  onRegenerate,
}) => {
  const [prompt, setPrompt] = useState(initialPrompt || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    const promptValue = prompt.trim() || undefined;
    onClose?.();
    onRegenerate?.(promptValue);
  };

  return (
    <Modal onClose={onClose} maxWidth="max-w-md" heightClass="h-auto max-h-[90vh]">
      <h2 className="text-lg font-semibold text-theme-text mb-1">Regenerate visual</h2>
      <p className="text-sm text-theme-text opacity-60 mb-4">
        Scene {sceneNumber}. Edit the prompt below or leave it as-is.
      </p>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <textarea
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          rows={5}
          className="w-full rounded-lg border border-theme-secondary bg-theme-secondary bg-opacity-30 px-3 py-2 text-sm text-theme-text focus:outline-none focus:ring-2 focus:ring-theme-primary"
          placeholder="Visual description for this scene"
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-theme-secondary px-4 py-2 text-sm text-theme-text opacity-70 hover:bg-theme-secondary focus:outline-none focus:ring-2 focus:ring-theme-primary"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="rounded-lg bg-theme-primary px-4 py-2 text-sm font-medium text-theme-button hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-theme-primary"
          >
            Regenerate
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default RegenerateVisualModal;
